<template>
    <div class="bid-opening-page h100">
        <van-search
            v-model="filter.filter"
            placeholder="请输入搜索关键词"
            @search="onSearch"
        />
        <van-cell title="选择日期区间" :value="date" @click="showTime = true" />
        <van-calendar
            v-model="showTime"
            :min-date="minDate"
            type="range"
            @confirm="onSearch"
        />
        <van-tabs v-model="active" @change="tabChange">
            <van-tab
                v-for="(item, index) in type"
                :key="item.label"
                :title="item.label"
            >
                <base-list
                    :ref="`baseList${index}`"
                    :api="getApi"
                    :filter="{ ...filter, ...item.filter }"
                    :mapping-data="mappingData"
                >
                    <template v-slot:default="scope">
                        <bid-opening-item :data="scope.data" @handleClick="select" />
                    </template>
                </base-list>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import { Search, Cell, Calendar, Tab, Tabs } from 'vant'
    import bidOpeningItem from '@/components/bidOpeningItem'
    import dayjs from 'dayjs'
    const {
        listApi,
        filter,
        type,
        mixin,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/bidOpening`)
    import baseList from '@/components/baseList'
    export default {
        name: 'SearchPage',
        components: {
            [Search.name]: Search,
            [Cell.name]: Cell,
            [Calendar.name]: Calendar,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            baseList,
            bidOpeningItem,
        },
        mixins: [mixin],
        data() {
            return {
                loading: false,
                getApi: listApi,
                filter: JSON.parse(JSON.stringify(filter)),
                date: `${dayjs()
                    .subtract(3, 'month')
                    .format('YYYY-MM-DD')} - ${dayjs().format('YYYY-MM-DD')}`,
                showTime: false,
                minDate: dayjs('1991-1-1').toDate(),
                type,
                active: 0,
            }
        },
        methods: {
            select(row) {
                this.$router.push({
                    name: 'BidOpeningDetail',
                    query: {
                        id: row._id,
                    },
                })
            },
            onSearch(val) {
                this.showTime = false
                this.date = `${dayjs(val[0]).format('YYYY-MM-DD')} - ${dayjs(
                    val[1],
                ).format('YYYY-MM-DD')}`
                this.filter = { ...this.filter, startDate: val[0], endDate: val[1] }
                this.$nextTick(() => {
                    this.$refs[`baseList${this.active}`][0].refresh()
                })
            },
            tabChange() {
                if (this.typeChange) {
                    this.typeChange()
                }
            },
        },
    }
</script>

<style lang="scss">
@import "../../assets/style/projectList.scss";
.bid-opening-page {
  background: url("../../assets/images/background/xiangmubeijin.png") no-repeat;
  background-position: 0px -90px;
  background-size: 100%;
  .van-tabs {
    background: #ffffff;
    height: calc(100% - 100px);
    .van-tabs__wrap {
      border-radius: 10px 10px 0 0;
    }
  }
  .van-tab {
    flex: 0 0 auto !important;
    padding: 0px 10px;
  }
  .van-tabs__line {
    background-color: rgba(0, 146, 63, 1) !important;
    height: 2px !important;
  }
  .van-search {
    background: none;
  }
  .van-cell {
    border-radius: 10px 10px 0 0;
  }
}
</style>
